// Admin only, on a band page: the one HOARD passcode that signs this band in to its own page from /musician.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Copy } from "lucide-react";
import { API } from "../../App";
import { auth, errMsg, groupCode } from "../voltbox/vbShared";

const SITE = "https://lookwashington.com";

export const BandPasscodeAdmin = ({ slug, name }) => {
  const [st, setSt] = useState(null);
  const [fresh, setFresh] = useState(null);
  const load = useCallback(() => axios.get(`${API}/admin/bands/${slug}/hoard-passcode`, auth()).then((r) => setSt(r.data)).catch(() => setSt(false)), [slug]);
  useEffect(() => { load(); }, [load]);
  const make = async () => {
    if (st?.has_code && !window.confirm("Make a new passcode? The old one stops working and signs out every device using it.")) return;
    try { const { data } = await axios.post(`${API}/admin/bands/${slug}/hoard-passcode`, {}, auth()); setFresh(data.passcode); load(); } catch (e) { toast.error(errMsg(e, "Couldn't make a passcode")); }
  };
  const off = async () => { if (!window.confirm("Turn off this band's passcode?")) return; await axios.delete(`${API}/admin/bands/${slug}/hoard-passcode`, auth()).catch(() => {}); setFresh(null); load(); };
  if (st === false) return null;
  const invite = fresh && `Your page on THE WALL — ${name}\nSign in: ${SITE}/musician\nPasscode: ${groupCode(fresh)}\n\nTap "I have a passcode", type it in, and you can update your page and add shows any time.`;
  return (
    <div className="mb-8 rounded-2xl border-2 border-dashed border-[#2E5C55]/40 bg-[#F4F8F6] p-4 sm:p-5 text-[#1A1A1A]" data-testid="band-passcode-admin">
      <div className="flex items-center gap-2 flex-wrap">
        <KeyRound className="h-4 w-4 text-[#2E5C55]" />
        <p className="m-0 font-bold">HOARD passcode <span className="text-xs font-normal text-[#5C5C5C]">· admin only</span></p>
        <span className="text-xs text-[#5C5C5C]" data-testid="band-passcode-status">{!st ? "…" : st.has_code ? `On · used ${st.uses}× · ${st.signed_in} device${st.signed_in === 1 ? "" : "s"} signed in` : "No passcode yet"}</span>
        <div className="ml-auto flex gap-2">
          <button type="button" onClick={make} className="rounded-full bg-[#2E5C55] text-white px-3.5 py-1.5 text-xs font-bold" data-testid="band-passcode-make">{st?.has_code ? "New passcode" : "Make passcode"}</button>
          {st?.has_code && <button type="button" onClick={off} className="rounded-full border border-[#C0392B]/40 text-[#C0392B] px-3 py-1.5 text-xs font-bold" data-testid="band-passcode-off">Turn off</button>}
        </div>
      </div>
      <p className="m-0 mt-1 text-xs text-[#5C5C5C]">The band types it at /musician → “I have a passcode” and lands on this page&rsquo;s editor. It only unlocks this band page.</p>
      {fresh && (
        <div className="mt-3 rounded-xl bg-white border border-[#2E5C55]/30 p-3" data-testid="band-passcode-fresh">
          <p className="m-0 text-[10px] font-black uppercase tracking-[0.2em] text-[#E76F51]">Shown only now</p>
          <p className="m-0 mt-1 font-mono text-2xl font-bold tracking-[0.15em]" data-testid="band-passcode-code">{groupCode(fresh)}</p>
          <button type="button" onClick={() => navigator.clipboard?.writeText(invite).then(() => toast.success("Invite copied"))} className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#1A1A1A] text-white px-3.5 py-1.5 text-xs font-bold" data-testid="band-passcode-copy"><Copy className="h-3.5 w-3.5" /> Copy the invite</button>
        </div>
      )}
    </div>
  );
};
